import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';
import { spin } from '../../utils/style';

import { NewStyleColor, BaseStyledComponentProps } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';

interface WrapperProps {
	isDisplayed: boolean;
	isDownloadManagerActive: boolean;
	screenWidth: number;
}

interface ToggleProps {
	isExpanded: boolean;
}

const Wrapper = styled('div')`
	position: absolute;
	bottom: 0;
	right: ${(props: WrapperProps) => {
		// If screen is wide enough (> 650px) AND download manager is active, position side by side
		if (props.isDisplayed && props.isDownloadManagerActive && props.screenWidth > 650) {
			return '330px';
		}
		return '0';
	}};
	z-index: 10;
	width: 320px;
	border-radius: 9px 9px 0 0;
	background-color: ${NewStyleColor.White};
	box-shadow: 0 2px 26px 0 ${hexToRgba(NewStyleColor.Black, 25)};
	color: ${NewStyleColor.Black};
	transform: ${(props: WrapperProps) => props.isDisplayed ? 'translateY(0)' : 'translateY(150%)'};
	transition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, right 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;

const StyledHeader = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	height: 40px;
	padding: 20px;
	padding-right: 15px;
	border-radius: inherit;
	background-color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};

	> span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

const Title = styled(Translate)`
	font-family: HelveticaNeue, sans-serif;
	font-size: 13px;
	line-height: 20px;
	color: ${NewStyleColor.White};
`;

const buttonCommonStyles = `
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px;
	border: 0;
	outline: 0;
	background-color: transparent;
	cursor: pointer;

	svg {
		fill: ${NewStyleColor.White};
	}
`;

const Toggle = styled('button')`
	${buttonCommonStyles}
	margin-left: auto;

	${({ isExpanded }: ToggleProps) => !isExpanded && 'transform: rotate(180deg);'}

	svg {
		width: 11px;
		height: 11px;
	}
`;

const ButtonClose = styled('button')`
	${buttonCommonStyles}

	svg {
		width: 9px;
		height: 9px;
	}
`;

const ContentWrapper = styled('div')`
	padding: 20px;
	font-size: 12px;
	line-height: 16px;

	.icon-and-text {
		display: flex;
		align-items: center;
	}

	.text > span {
		display: block;
	}

	svg {
		height: 20px;
		width: 20px;
		margin-right: 5px;
		animation: ${spin};
	}
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
`;

const ContentButton = styled('button')`
	${buttonCommonStyles}

	min-width: 100px;
	margin: 20px auto 0;
	padding: 5px 10px;
	border-radius: 4px;
	background-color: ${({ backgroundColor }) => backgroundColor};
	color: ${({ color }) => color || 'inherit'};
	font-family: 'HelveticaNeue', sans-serif;
	font-weight: 700;
	font-size: 12px;
	line-height: 12px;
`;

export {
	Wrapper,
	StyledHeader,
	Title,
	Toggle,
	ButtonClose,
	ContentWrapper,
	ContentButton,
	ButtonContainer,
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContentStructureToast/styles.ts